class clickHelper {
    constructor() {
        this.initExternalClickModal();
    }

    initExternalClickModal() {
        Array.from( document.querySelectorAll( 'a' ) ).forEach( el => {
            // check if href is local
            if(location.hostname != el.hostname && el.hostname.length) {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    modal = document.getElementById('modal-external-gate');
                    modal.querySelector('.external-link').href = el.href;
                    modal.querySelector('.external-link').target = el.target;
                    $(modal).modal('show');
                });
            }
        });
    }

    toggleMobileMenu(el) {
        el.addEventListener('click', (e) => {
            if (document.body.clientWidth <= 992) {
                document.getElementById('main-nav').classList.toggle('open');
            }
        });
    }

    toggleSlideoutMenu(el) {
        el.addEventListener('click', (e) => {
            let target = e.currentTarget.getAttribute('data-target');
            let slideout = document.getElementById(target);
            let duration = 100; // matches the timing of the opacity transition

            if (!slideout.classList.contains('in-the-dom')) {
                this.showSlideoutAnimation(slideout, duration);
                this.focusSlideoutTextFields(slideout, target);
                this.setupEscKeyListener(slideout, duration);
            } else {
                this.hideSlideoutAnimation(slideout, duration);
            }
        });
    }

    showSlideoutAnimation(slideout, duration) {
        slideout.classList.add('in-the-dom');
        setTimeout(() => slideout.classList.add('visible-to-user'), duration);
    }

    hideSlideoutAnimation(slideout, duration) {
        slideout.classList.remove('visible-to-user');
        setTimeout(() => slideout.classList.remove('in-the-dom'), duration);
    }

    focusSlideoutTextFields(slideout, target) {
        // only focus text fields when either slideout is in view
        // let classes = ['in-the-dom', 'visible-to-user'];
        // let hasAllClasses = classes.every(c => slideout.classList.contains(c));
        // 'visible-to-user' class isn't on the element yet...

        if (slideout.classList.contains('in-the-dom')) {
            let selector = null;
            if (target === 'search_slideout') {
                selector = '#search_slideout input[type="text"]';
            } else if (target == 'login_slideout') {
                selector = '#login_slideout input[type="text"]';
            }

            let inputField = document.querySelector(selector);
            inputField.value = null;
            inputField.focus();
        }
    }

    setupEscKeyListener(slideout, duration) {
        document.addEventListener('keyup', e => {
            const escKeyCode = 27;
            if (e.keyCode === escKeyCode) {
                this.hideSlideoutAnimation(slideout, duration);
            }
        });
    }

    toggleAccordionRow(el) {
        el.addEventListener('click', (e) => {
            let chevron = document.getElementById(e.currentTarget.getAttribute('data-chevron-target'));
            chevron.classList.toggle('open');
        });
    }
}

window.app.add('click', new clickHelper());
